// Detalles de usuario


import React from "react";
import {
  Card,
  CardContent,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableBody,
  Typography, Grid, Chip, Divider, TableRow
} from "@mui/material";
import { getUserTypeLabel } from "./UserType";
import { formatMX } from "../util/DateUtil";

export default function UserInfoCard({ user }) {
  if (!user) return null;

  return (
    <TableContainer component={Paper} sx={{ mb: 2, maxWidth: 600, margin: "2rem auto" }}>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell colSpan={2}>
              <Typography variant="h6" sx={{ mb: 2 }}>Información de Usuario</Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell><strong>ID:</strong></TableCell>
            <TableCell> {user.id}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell><strong>Email:</strong></TableCell>
            <TableCell> {user.email}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell><strong>Rol:</strong></TableCell>
            <TableCell> {getUserTypeLabel(user.role)}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell><strong>Creado:</strong></TableCell>
            <TableCell> {formatMX(user.createdAt)}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell><strong>Actualizado:</strong></TableCell>
            <TableCell> {formatMX(user.updatedAt)}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}